import { observable } from "mobx";

export default class ManufacturePanel {
    @observable probeID?: string;
    @observable catalogPanelName?: string;
    @observable commonName?: string;
    @observable remark?: string;
    @observable manufacturePanelName?: string;
}